import { track } from '@bnnvara/analytics/src/track';
import { DropdownItem } from '@bnnvara/hub';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import { AccessoryLeft } from './AccessoryLeft';
import { getHrefStructure } from './getHrefStructure';
import { Subtitle } from './Subtitle';
import { Title } from './Title';

const NotificationDropdownItem = ({
  action,
  slug,
  brand,
  date,
  publication,
  thumbnail,
  isRead,
  setNotificationsOnRead,
  ...props
}) => {
  const brandName = brand && brand.name;
  /**
   * This key is send to GA
   */
  const key = `${action}${brandName ? `-${brandName}` : ''}${
    publication ? `-${publication.slug}` : ''
  }`;
  const isHighlighted =
    action !== 'subscribedToBrand' && action !== 'subscribedToFirstBrand';
  const publicationTitle = publication && publication.title;

  if (action) {
    return (
      <Link href={getHrefStructure(action, brand)} as={slug} key={key}>
        <DropdownItem
          showDot={!isRead}
          title={Title({ action, brandName, title: publicationTitle })}
          subtitle={Subtitle({ brand, action, date })}
          accessoryLeft={AccessoryLeft({ action, thumbnail })}
          isHighlighted={isHighlighted}
          onClick={() => {
            track('notificatie', 'click', key);
            setNotificationsOnRead();
          }}
          {...props}
        />
      </Link>
    );
  }
  return null;
};

NotificationDropdownItem.propTypes = {
  setNotificationsOnRead: PropTypes.func,
  index: PropTypes.number,
  thumbnail: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    url: PropTypes.string,
    altText: PropTypes.string,
  }),
  isRead: PropTypes.bool.isRequired,
  slug: PropTypes.string.isRequired,
  date: PropTypes.string,
  action: PropTypes.string.isRequired,
  brand: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
  publication: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    slug: PropTypes.string,
    title: PropTypes.string,
  }),
};

export { NotificationDropdownItem };
